import { RootState } from '@/store'

export const getToolbars = (state: RootState) => {
  return (state.organizationToolbarsPage && state.organizationToolbarsPage.toolbars) || []
}

export const getCurrentToolbar = (state: RootState) => {
  return (
    (state.organizationToolbarsPage &&
      state.organizationToolbarsPage.toolbars.find(toolbar => toolbar.currentToolbar === true)) ||
    {}
  )
}
